import { Component, Fragment, forwardRef } from "react";
import Loader from "../../../utils/Loader";
import { ToastContainer } from "react-toastify";
import Pagination from "../../../utils/pagination";
import { withRouter } from "../../../utils/withRouter";
import { connect } from "react-redux";
import { fill_action } from "../../../actions/fillCombo_action";
import AdminDrawer from "../../../common_components/admin_module_drawer";
import HeaderWithLogo from "../../../common_components/header_with_logo";
import "react-datepicker/dist/react-datepicker.css";
import ExhibitorHeader from "../../../common_components/exhibitor_module_header";
import ExhibitorDrawer from "../../../common_components/exhibitor_module_drawer";
import ExhibitorTopMenu from "../../../common_components/exhibitor_module_topmenu";
import VendorDrawer from "../../../common_components/vendor_module_drawer";
import {
  getVendorWorkOrderList_action,
  deleteVendorWorkOrder_action,
} from "../../../actions/admin_module_action/vendor_action/vendorWorkOrder_action/vendorWorkOrder_action";
import {
  getVendorTaskList_action,
  updateVendorTask_action,
} from "../../../actions/vendor_module_action/vendor_task_action";
import {
  exhibitionId,
  serviceTypeId,
  toastError,
  toastSuccess,
} from "../../../utils/constants";
import {
  ATTACHMENT_ACTION_ADD,
  ATTACHMENT_ACTION_REMOVE,
  MAX_ATTACHMENTS,
  capAttachments,
  extractAttachmentRows,
  getAttachmentName,
  getAttachmentUrl,
  normalizeAttachmentRow,
  pickAttachmentFile,
} from "../../../utils/vendor_attachment_helper";
import {
  formatServerDateTime,
  serverDateTimeValue,
} from "../../../utils/vendor_datetime_helper";
import Select from "react-select";
import Modal from "react-modal";
import moment from "moment";
import * as XLSX from "xlsx-js-style";

const styles = {
  width: "100%",
};

class VendorTaskDetail extends Component {
  constructor(props) {
    super(props);
    this._pendingRequests = 0;
    this.state = {
      isLoading: false,
      workOrderList: [],
      vendorPlanList: [],
      subPointCompletionStatus: {}, // Track sub-point completion
      subPointApprovalStatus: {}, // Track sub-point admin approval
      subPointHallApprovalStatus: {}, // Track sub-point hall manager approval
      subPointZoneApprovalStatus: {}, // Track sub-point zone manager approval
      currentPage: 1,
      ExhibitionID: sessionStorage.getItem("sessionExhibitionID"),
      exhibitionList: [],
      WorkOrderNumber: "",
      PersonName: "",
      ServiceID: [],
      serviceTypeList: [],
      Status: "",
      EmailID: "",
      WorkOrderServiceList: [],
      isOpen: false,
      sortField: "",
      sortOrder: "",
      isVendor: JSON.parse(sessionStorage.getItem("loginDataSS")).RoleID == 7 || JSON.parse(sessionStorage.getItem("loginDataSS")).RoleID == 17,
      // Verification is the organizer's own tick, kept apart from the completion
      // the service partner reports. Super Admin (6) and Admin (2) both count as
      // the Organizer, matching what the SP allows and who the notifications treat
      // as the Organizer team
      isAdmin:
        JSON.parse(sessionStorage.getItem("loginDataSS")).RoleID == 6 ||
        JSON.parse(sessionStorage.getItem("loginDataSS")).RoleID == 2,
      // The hall manager has an approval of their own, one step before the
      // organizer's. Both columns are shown to every role, because the pair of
      // them is what decides whether anyone else may still touch the row
      isHallManager: JSON.parse(sessionStorage.getItem("loginDataSS")).RoleID == 16,
      // The Zone Manager is the first tier to verify a completed task. Their tick
      // locks the row for the service partner, and the hall manager's locks it for
      // them in turn
      isZoneManager: JSON.parse(sessionStorage.getItem("loginDataSS")).RoleID == 25,
      filterStatus: "all",
      taskCounts: { completed: 0, hallCompleted: 0, pending: 0, overdue: 0 },
      selectedHall: null,
      selectedZone: null,
      selectedService: null,
      selectedVendor: null,
      showVideoModal: false,
      remarkSource: [], // Flat remark rows as they come from the API
      remarkDetails: {}, // Chat threads keyed by task / sub-point
      showRemarkModal: false,
      activeRemarkKey: null,
      activeRemarkTitle: "",
      activeRemarkTarget: null,
      newRemark: "",
      attachmentDetails: {}, // Attachments keyed by task / sub-point
      showAttachmentModal: false,
      activeAttachmentKey: null,
      activeAttachmentTitle: "",
      activeAttachmentTarget: null,
    };
    this.updateItem = this.updateItem.bind(this);
    this.pollingTimer = null;
    this.isTaskUpdateInFlight = false;
  }

  startLoading() {
    this._pendingRequests += 1;
    this.setState({ isLoading: true });
  }

  stopLoading() {
    this._pendingRequests = Math.max(0, this._pendingRequests - 1);
    if (this._pendingRequests === 0) {
      this.setState({ isLoading: false });
    }
  }

  componentDidMount() {
    this.applyIncomingFilters();
    this.getFillList(exhibitionId, "", "", "", "", "");
    this.getFillList(serviceTypeId, "", "", "", "", "");
    this.getWorkOrderList();
    this.getVendorTaskList();
    this.startPolling();
  }

  componentWillUnmount() {
    this.stopPolling();
  }

  // Refresh the task list every 15s in the background (no page reload, no loader flicker)
  startPolling() {
    this.stopPolling();
    this.pollingTimer = setInterval(() => {
      // Don't refresh while a modal is open or a task update is still saving,
      // otherwise the in-progress work gets overwritten by stale server data
      if (
        this.state.isOpen ||
        this.state.showVideoModal ||
        this.isTaskUpdateInFlight ||
        document.hidden
      ) {
        return;
      }
      this.getVendorTaskList(this.state.filterStatus, true);
    }, 15000);
  }

  stopPolling() {
    if (this.pollingTimer) {
      clearInterval(this.pollingTimer);
      this.pollingTimer = null;
    }
  }

  // Every role opens on the bucket it is the one expected to act on:
  //   Service Partner (7 / 17)            -> what they are running late on
  //   Organizer team (2 / 6)              -> work the hall manager has signed off,
  //                                          waiting on the organizer's own tick
  //   Hall Manager (16 / 25), Team Member (20)
  //                                       -> work the service partner has finished
  //                                          and that is waiting on their approval
  // Anyone else keeps the full list.
  getRoleDefaultFilter = () => {
    const roleID = Number(
      JSON.parse(sessionStorage.getItem("loginDataSS"))?.RoleID
    );

    if (roleID === 7 || roleID === 17) return "overdue";
    if (roleID === 2 || roleID === 6) return "hallcompleted";
    if (roleID === 16 || roleID === 20 || roleID === 25) return "completed";

    return null;
  };

  // The counts come off the unfiltered load, so the role's bucket is applied once
  // that has landed rather than on mount - otherwise every badge would read 0.
  // Runs once per mount, and a filter carried in from another screen wins over it.
  applyRoleDefaultFilter() {
    if (this.roleDefaultApplied) return;
    this.roleDefaultApplied = true;

    if (this.pendingFilter?.status && this.pendingFilter.status !== "all") return;

    const roleDefault = this.getRoleDefaultFilter();
    if (!roleDefault || roleDefault === this.state.filterStatus) return;

    this.setFilter(roleDefault);
  }

  // The layout view sends a booth's hall / service / service partner over so the
  // organizer lands on the rows they were looking at on the map.
  //
  // These arrive as display strings from sp_get_vendorauditTracker, while this
  // screen's own list comes from sp_get_ExhVendorTaskDetails. The two do not
  // always spell a value the same way - "Grade Electricals Pvt Ltd " carries a
  // trailing space in one of them - and setting a react-select value that
  // matches nothing filters the table down to zero rows, which reads as "the
  // service column is missing" rather than "the filter missed".
  //
  // So the filter is held until the list has loaded and then matched against the
  // values actually present. Anything that does not match is dropped, which
  // shows more rows rather than none.
  applyIncomingFilters() {
    const incoming =
      this.props.taskFilter || this.props.location?.state?.taskFilter;
    if (!incoming) return;

    this.pendingFilter = incoming;

    if (incoming.status && incoming.status !== "all") {
      this.setState({ filterStatus: incoming.status });
    }

    // Embedded there is no route to clean.
    if (
      !this.props.embedded &&
      this.props.location?.state?.taskFilter &&
      this.props.navigate
    ) {
      this.props.navigate(this.props.location.pathname, {
        replace: true,
        state: {},
      });
    }
  }

  // Trim and case-fold, so spacing and casing differences between the two SPs
  // do not decide whether a filter lands.
  matchOption = (wanted, values) => {
    if (!wanted) return null;
    const key = String(wanted).trim().toLowerCase();
    const hit = values.find(
      (v) => v != null && String(v).trim().toLowerCase() === key
    );
    return hit ? { value: hit, label: hit } : null;
  };

  resolvePendingFilter(resultSet) {
    const incoming = this.pendingFilter;
    if (!incoming || !resultSet || resultSet.length === 0) return;
    this.pendingFilter = null;

    const halls = resultSet.map((t) => t.HallName);
    const services = resultSet.map((t) => t.ServiceName);
    const vendors = resultSet.map((t) => t.CompanyName);

    const selectedHall = this.matchOption(incoming.hallName, halls);
    const selectedService = this.matchOption(incoming.serviceName, services);
    const selectedVendor = this.matchOption(incoming.vendorCompany, vendors);

    const missed = [
      incoming.hallName && !selectedHall ? `hall "${incoming.hallName}"` : null,
      incoming.serviceName && !selectedService
        ? `service "${incoming.serviceName}"`
        : null,
      incoming.vendorCompany && !selectedVendor
        ? `service partner "${incoming.vendorCompany}"`
        : null,
    ].filter(Boolean);

    if (missed.length > 0) {
      // Say so rather than silently showing a wider list than was asked for
      console.warn(
        `[task filter] not applied - ${missed.join(
          ", "
        )} matches no row in this list`
      );
    }

    this.setState({ selectedHall, selectedService, selectedVendor });
  }

  // isSilent = background poll: keep the loader hidden and don't toast transient errors
  getVendorTaskList(statusFilter = "all", isSilent = false) {
    const vendorID = JSON.parse(sessionStorage.getItem("AccountIDSS"));
    let StatusID = null;

    if (statusFilter === "pending") StatusID = "0";
    else if (statusFilter === "completed") StatusID = 1; // completed, hall manager pending
    else if (statusFilter === "hallcompleted") StatusID = 4; // completed, hall manager approved
    else if (statusFilter === "overdue") StatusID = 2;
    else StatusID = 3; // For 'all', pass 3 to get all records

    if (!isSilent) this.startLoading();
    try {
      this.props
        .getVendorTaskList_action(vendorID, StatusID)
        .then((data) => {
          if (data.error != 1) {
            const resultSet = data.data.vendorPlanList || [];
            const remarkSource = this.extractRemarkRows(data.data);
            const attachmentSource = extractAttachmentRows(data.data);

            // Load sub-point completion status from API
            const subPointCompletionStatus = {};
            // Sub point approval rides on the same rows, under IsAdminApproveSub
            // for the organizer and IsHallManagerApproveSub for the hall manager
            const subPointApprovalStatus = {};
            const subPointHallApprovalStatus = {};
            const subPointZoneApprovalStatus = {};
            const subPointsByTask = {};

            resultSet.forEach((task) => {
              const taskId = task.ExhVendorPlanDtlID;

              // Group sub-points by task
              if (!subPointsByTask[taskId]) {
                subPointsByTask[taskId] = [];
              }

              if (task.SubPoint && task.SubPoint.trim()) {
                const subPointExists = subPointsByTask[taskId].some(
                  (sp) => sp.SubPoint === task.SubPoint
                );

                if (!subPointExists) {
                  const spIndex = subPointsByTask[taskId].length;
                  subPointsByTask[taskId].push({
                    SubPoint: task.SubPoint,
                    ExhVendorPointDtlID: task.ExhVendorPointDtlID,
                  });

                  // Set completion status from API
                  const key = `${taskId}_${spIndex}`;
                  subPointCompletionStatus[key] =
                    task.IsCompletedPoint === 1 || task.IsCompletedPoint === true;
                  subPointApprovalStatus[key] =
                    task.IsAdminApproveSub === 1 ||
                    task.IsAdminApproveSub === true;
                  subPointHallApprovalStatus[key] =
                    task.IsHallManagerApproveSub === 1 ||
                    task.IsHallManagerApproveSub === true;
                  subPointZoneApprovalStatus[key] =
                    task.IsZoneManagerApproveSub === 1 ||
                    task.IsZoneManagerApproveSub === true;

                  if (!isSilent) {
                    console.log(
                      `Sub-point ${key}: IsCompletedPoint=${task.IsCompletedPoint}, checked=${subPointCompletionStatus[key]}`
                    );
                  }
                }
              }
            });

            if (StatusID === 3) {
              // Completed tasks split into the two hall manager buckets
              const completedTasks = resultSet.filter(
                (task) => task.IsCompleted === true,
              );
              const hallCompletedCount = completedTasks.filter((task) =>
                this.isFlagOn(task.IsHallManagerApprove),
              ).length;
              const completedCount = completedTasks.length - hallCompletedCount;
              const pendingCount = resultSet.filter(
                (task) =>
                  (task.IsCompleted === false || task.IsCompleted === null) &&
                  (!task.Overdue || task.Overdue === ""),
              ).length;
              const overdueCount = resultSet.filter(
                (task) => task.Overdue && task.Overdue !== "",
              ).length;

              this.setState({
                vendorPlanList: resultSet,
                subPointCompletionStatus,
                subPointApprovalStatus,
                subPointHallApprovalStatus,
                subPointZoneApprovalStatus,
                remarkSource,
                remarkDetails: this.buildRemarkThreads(resultSet, remarkSource),
                attachmentDetails: this.buildAttachmentMap(
                  resultSet,
                  attachmentSource
                ),
                taskCounts: {
                  completed: completedCount,
                  hallCompleted: hallCompletedCount,
                  pending: pendingCount,
                  overdue: overdueCount,
                },
              }, () => {
                this.resolvePendingFilter(resultSet);
                this.applyRoleDefaultFilter();
              });
            } else {
              this.setState({
                vendorPlanList: resultSet,
                subPointCompletionStatus,
                subPointApprovalStatus,
                subPointHallApprovalStatus,
                subPointZoneApprovalStatus,
                remarkSource,
                remarkDetails: this.buildRemarkThreads(resultSet, remarkSource),
                attachmentDetails: this.buildAttachmentMap(
                  resultSet,
                  attachmentSource
                ),
              }, () => this.resolvePendingFilter(resultSet));
            }
          } else if (!isSilent) {
            toastError(data.msg);
          }
          if (!isSilent) this.stopLoading();
        })
        .catch((err) => {
          console.log("Error in getVendorTaskList:", err);
          if (!isSilent) this.stopLoading();
        });
    } catch (error) {
      console.log("Exception in getVendorTaskList:", error);
      if (!isSilent) {
        toastError("Something went wrong!");
        this.stopLoading();
      }
    }
  }

  setFilter = (status) => {
    this.setState({ filterStatus: status });
    this.getVendorTaskList(status);
  };

  getWorkOrderList() {
    const {
      ExhibitionID,
      WorkOrderNumber,
      ServiceID,
      PersonName,
      EmailID,
      Status,
    } = this.state;
    this.startLoading();
    const servicesids = ServiceID.map((item) => item.value).join(",");
    try {
      this.props
        .getVendorWorkOrderList_action(
          ExhibitionID,
          WorkOrderNumber,
          servicesids,
          PersonName,
          EmailID,
          Status != "" ? Status : 1,
        )
        .then((data) => {
          if (data.error != 1) {
            this.setState({ workOrderList: data.data });
          } else {
            toastError(data.msg);
          }
          this.stopLoading();
        })
        .catch((err) => {
          console.log(err);
          this.stopLoading();
        });
    } catch {
      toastError("Something went wrong!");
      this.stopLoading();
    }
  }

  deleteWorkOrder() {
    const { WorkOrderID, ExhibitionID } = this.state;
    this.startLoading();
    try {
      this.props
        .deleteVendorWorkOrder_action(WorkOrderID, ExhibitionID)
        .then((data) => {
          if (data.error != 1) {
            this.setState({ isOpen: false });
            this.clearValue();
            toastSuccess("Deleted successfully!");
          } else {
            toastError(data.msg);
          }
          this.stopLoading();
        })
        .catch((err) => {
          console.log(err);
          this.stopLoading();
        });
    } catch {
      toastError("Something went wrong!");
      this.stopLoading();
    }
  }

  updateItem(item) {
    const { workOrderList } = this.state;
    this.setState({ currentPage: item });
    const recordsPerPage = 10;
    const indexOfLastRecord = item * recordsPerPage;
    const indexOfFirstRecord = indexOfLastRecord - recordsPerPage;
    const currentRecords = workOrderList.slice(
      indexOfFirstRecord,
      indexOfLastRecord,
    );
    const nPages = Math.ceil(workOrderList.length / recordsPerPage);
  }

  // get fill List dropdown
  getFillList(
    actionID,
    exhibitionID,
    moduleID,
    keyValue,
    value,
    exhRegistrationID,
  ) {
    const { } = this.state;
    this.startLoading();
    this.props
      .fill_action(
        actionID,
        exhibitionID,
        moduleID,
        keyValue,
        value,
        exhRegistrationID,
      )
      .then((data) => {
        if (data.error != 1) {
          if (actionID === exhibitionId) {
            this.setState({ exhibitionList: data.data });
          }
          if (actionID === serviceTypeId) {
            this.setState({ WorkOrderServiceList: data.data });
          }
        } else {
          toastError(data.msg);
        }
        this.stopLoading();
      })
      .catch((e) => {
        console.log(e);
        this.stopLoading();
      });
  }

  clearValue() {
    this.setState({
      ExhibitionID: "",
      WorkOrderNumber: "",
      PersonName: "",
      ServiceID: [],
      EmailID: "",
      Status: 1,
    });

    setTimeout(() => {
      this.getWorkOrderList();
    }, 100);
  }

  handleSort = (field) => {
    const { sortField, sortOrder, workOrderList } = this.state;
    const newSortOrder =
      sortField === field && sortOrder === "asc" ? "desc" : "asc";

    const sortedData = [...workOrderList].sort((a, b) => {
      const aVal = a[field];
      const bVal = b[field];

      // Handle numbers vs strings
      if (typeof aVal === "number" && typeof bVal === "number") {
        return newSortOrder === "asc" ? aVal - bVal : bVal - aVal;
      }

      const aStr = (aVal || "").toString().toLowerCase();
      const bStr = (bVal || "").toString().toLowerCase();

      if (aStr < bStr) return newSortOrder === "asc" ? -1 : 1;
      if (aStr > bStr) return newSortOrder === "asc" ? 1 : -1;
      return 0;
    });

    this.setState({
      workOrderList: sortedData,
      sortField: field,
      sortOrder: newSortOrder,
    });
  };

  toggleDateCompletion = (date) => {
    const { vendorPlanList } = this.state;
    const groupedTasks = this.groupTasksByDate();
    const tasksForDate = groupedTasks[date];
    const allCompleted = tasksForDate.every((task) => task.IsCompleted);
    const newStatus = !allCompleted;

    const updatedList = vendorPlanList.map((task) => {
      const taskDate = new Date(task.StartTime).toDateString();
      if (taskDate === date) {
        return { ...task, IsCompleted: newStatus };
      }
      return task;
    });

    this.setState({ vendorPlanList: updatedList }, () => {
      this.updateVendorTasks(
        tasksForDate.map((task) => ({
          ExhVendorplandtlID: task.ExhVendorPlanDtlID,
          IsCompleted: newStatus,
        })),
      );
    });
  };

  toggleServiceCompletion = (date, service) => {
    const { vendorPlanList } = this.state;
    const groupedTasks = this.groupTasksByDate();
    const tasksForService = groupedTasks[date].filter(
      (task) => task.Service === service,
    );
    const allCompleted = tasksForService.every((task) => task.IsCompleted);
    const newStatus = !allCompleted;

    const updatedList = vendorPlanList.map((task) => {
      const taskDate = new Date(task.StartTime).toDateString();
      if (taskDate === date && task.ServiceName === service) {
        return { ...task, IsCompleted: newStatus };
      }
      return task;
    });

    this.setState({ vendorPlanList: updatedList }, () => {
      this.updateVendorTasks(
        tasksForService.map((task) => ({
          ExhVendorplandtlID: task.ExhVendorPlanDtlID,
          IsCompleted: newStatus,
        })),
      );
    });
  };

  toggleDeliverableCompletion = (date, service, hall) => {
    const { vendorPlanList } = this.state;
    const groupedTasks = this.groupTasksByDate();
    const tasksForDeliverable = groupedTasks[date].filter(
      (task) => task.Service === service && task.HallName === hall,
    );
    const allCompleted = tasksForDeliverable.every((task) => task.IsCompleted);
    const newStatus = !allCompleted;

    const updatedList = vendorPlanList.map((task) => {
      const taskDate = new Date(task.StartTime).toDateString();
      if (
        taskDate === date &&
        task.ServiceName === service &&
        task.HallName === hall
      ) {
        return { ...task, IsCompleted: newStatus };
      }
      return task;
    });

    this.setState({ vendorPlanList: updatedList });
  };

  groupTasksByDate() {
    const { vendorPlanList } = this.state;
    const grouped = {};

    vendorPlanList.forEach((task) => {
      const startDate = new Date(task.StartTime);
      const dateStr = startDate.toDateString();

      if (!grouped[dateStr]) {
        grouped[dateStr] = [];
      }

      grouped[dateStr].push({
        ExhVendorPlanDtlID: task.ExhVendorPlanDtlID,
        Service: task.ServiceName,
        HallName: task.HallName,
        StartTime: task.StartTime,
        EndTime: task.EndTime,
        IsCompleted: task.IsCompleted,
        WorkOrderID: task.WorkOrderID,
        WorkOrderDeliverablesID: task.WorkOrderDeliverablesID,
      });
    });

    return grouped;
  }

  groupSubPointsByTask = (list = this.state.vendorPlanList) => {
    const vendorPlanList = list || [];
    const grouped = {};

    vendorPlanList.forEach((task) => {
      const taskId = task.ExhVendorPlanDtlID;

      if (!grouped[taskId]) {
        grouped[taskId] = [];
      }

      // Add sub-point if it exists
      if (task.SubPoint && task.SubPoint.trim()) {
        const subPointExists = grouped[taskId].some(
          (sp) => sp.SubPoint === task.SubPoint
        );

        if (!subPointExists) {
          grouped[taskId].push({
            SubPoint: task.SubPoint,
            ExhVendorPointDtlID: task.ExhVendorPointDtlID || null,
            StartDateTime: task.StartDateTime || null,
            EndDateTime: task.EndDateTime || null,
            // When each verification was given, stamped by the SP
            AdminApprovalDateTime: task.AdminApprovalDateTimeSub || null,
            HallManagerApprovalDateTime:
              task.HallManagerApprovalDateTimeSub || null,
            CompletionDateTime: task.CompletionDateTimeSub || null,
            IsZoneManagerApprove:
              task.IsZoneManagerApproveSub === 1 ||
              task.IsZoneManagerApproveSub === true,
            ZoneManagerApprovalDateTime:
              task.ZoneManagerApprovalDateTimeSub || null,
          });
        }
      }
    });

    return grouped;
  };

  // Bits come back as 1/0 from the API and as true/false from a local toggle that
  // has not been refreshed yet, so both shapes have to read the same
  isFlagOn = (value) => value === 1 || value === true;

  // Once the hall manager has approved, the service partner can no longer mark the
  // work complete. Once the organizer has approved, nothing but the organizer can
  // change it at all - approvals included
  isTaskLocked = (task) =>
    !this.state.isAdmin &&
    (this.isFlagOn(task.IsAdminApprove) ||
      this.isFlagOn(task.IsHallManagerApprove) ||
      // The zone tier is the first thing a completed task meets, so it is what
      // usually takes the tick away from the service partner
      this.isFlagOn(task.IsZoneManagerApprove));

  // A sub point is held by its own approvals and by its deliverable's
  isSubPointLocked = (planDtlId, spIndex) => {
    const {
      isAdmin,
      subPointApprovalStatus,
      subPointHallApprovalStatus,
      vendorPlanList,
    } = this.state;

    if (isAdmin) return false;

    const key = `${planDtlId}_${spIndex}`;
    const task = vendorPlanList.find(
      (t) => t.ExhVendorPlanDtlID === planDtlId
    );

    return (
      !!subPointApprovalStatus[key] ||
      !!subPointHallApprovalStatus[key] ||
      !!this.state.subPointZoneApprovalStatus[key] ||
      (!!task && this.isTaskLocked(task))
    );
  };

  // The zone tick is the Zone Manager's own until the Hall Manager verifies.
  // Both tiers above can still move it
  canSetZoneApproval = (isHallApproved, isOrganizerApproved) =>
    this.state.isAdmin ||
    (this.state.isHallManager && !isOrganizerApproved) ||
    (this.state.isZoneManager && !isHallApproved && !isOrganizerApproved);

  zoneLockedMessage = (isOrganizerApproved) =>
    isOrganizerApproved
      ? "Verified by Organizer - this row is frozen"
      : "Verified by Hall Manager - the zone tick can no longer be changed";

  // The hall manager's tick is theirs to set and to withdraw, right up until the
  // organizer approves - after that only the organizer can move anything
  canSetHallApproval = (isOrganizerApproved) =>
    this.state.isAdmin ||
    (this.state.isHallManager && !isOrganizerApproved);

  lockedMessage = (isOrganizerApproved) =>
    isOrganizerApproved
      ? "Verified by Organizer - this row is frozen"
      : "Verified by Hall Manager - this row can no longer be changed";

  toggleSubPointCompletion = (planDtlId, subPointIndex) => {
    const { subPointCompletionStatus, subPointApprovalStatus } = this.state;
    const key = `${planDtlId}_${subPointIndex}`;

    if (this.isSubPointLocked(planDtlId, subPointIndex)) {
      const task = this.state.vendorPlanList.find(
        (t) => t.ExhVendorPlanDtlID === planDtlId
      );
      toastError(
        this.lockedMessage(
          !!subPointApprovalStatus[key] ||
          (!!task && this.isFlagOn(task.IsAdminApprove))
        )
      );
      return;
    }

    const updatedStatus = {
      subPointCompletionStatus: {
        ...subPointCompletionStatus,
        [key]: !subPointCompletionStatus[key],
      },
    };

    this.setState(updatedStatus, () => {
      // Call API to update the sub-point status
      setTimeout(() => {
        this.updateSubPointStatus(planDtlId, subPointIndex);
      }, 100);
    });
  };

  // Only the sub point that was clicked goes over. Sending the whole set meant a
  // single tick also rewrote every other sub point from values this browser had
  // read earlier, undoing whatever anyone else had ticked in between
  updateSubPointStatus = (planDtlId, subPointIndex) => {
    const { subPointCompletionStatus } = this.state;
    const ExhVendorPlanHdrID = this.getPlanHdrIDForTask(planDtlId);

    const subPoint =
      this.groupSubPointsByTask()[planDtlId]?.[subPointIndex];

    if (!subPoint?.ExhVendorPointDtlID) {
      toastError("This sub point cannot be updated yet");
      return;
    }

    // Empty task details since we're only updating sub-points
    const taskDetails = [];
    const dailyRoutineTaskDetails = [];

    const subTaskDetails = [
      {
        ExhVendorPointDtlID: subPoint.ExhVendorPointDtlID,
        IsCompleted: subPointCompletionStatus[`${planDtlId}_${subPointIndex}`]
          ? 1
          : 0,
        Remark: null,
        ZoneID: this.getZoneIDForTask(planDtlId),
      },
    ];

    this.isTaskUpdateInFlight = true;
    this.props
      .updateVendorTask_action(
        ExhVendorPlanHdrID,
        taskDetails,
        subTaskDetails,
        dailyRoutineTaskDetails,
      )
      .then((data) => {
        if (data.error != 1) {
          console.log(`Task updated successfully!`);
          toastSuccess("Task updated successfully!");
          // Refresh the task list
          setTimeout(() => {
            this.getVendorTaskList();
            this.isTaskUpdateInFlight = false;
          }, 500);
        } else {
          toastError(data.msg);
          this.isTaskUpdateInFlight = false;
        }
      })
      .catch((err) => {
        console.log(err);
        toastError("Something went wrong!");
        this.isTaskUpdateInFlight = false;
      });
  };

  // Organizer approval of a sub point. Same shape as the completion toggle, but
  // the row carries IsCompleted: null so approving never touches the service
  // partner's own tick
  toggleSubPointApproval = (planDtlId, subPointIndex) => {
    const { subPointApprovalStatus, isAdmin } = this.state;

    if (!isAdmin) return;

    const key = `${planDtlId}_${subPointIndex}`;

    this.setState(
      {
        subPointApprovalStatus: {
          ...subPointApprovalStatus,
          [key]: !subPointApprovalStatus[key],
        },
      },
      () =>
        this.updateSubPointApproval(
          planDtlId,
          subPointIndex,
          "IsAdminApprove",
          !subPointApprovalStatus[key]
        )
    );
  };

  // Hall manager approval of a sub point - the same call, a different column, so
  // one approval never overwrites the other
  toggleSubPointHallApproval = (planDtlId, subPointIndex) => {
    const { subPointHallApprovalStatus, subPointApprovalStatus } = this.state;
    const key = `${planDtlId}_${subPointIndex}`;

    if (!this.canSetHallApproval(!!subPointApprovalStatus[key])) {
      if (this.state.isHallManager) toastError(this.lockedMessage(true));
      return;
    }

    this.setState(
      {
        subPointHallApprovalStatus: {
          ...subPointHallApprovalStatus,
          [key]: !subPointHallApprovalStatus[key],
        },
      },
      () =>
        this.updateSubPointApproval(
          planDtlId,
          subPointIndex,
          "IsHallManagerApprove",
          !subPointHallApprovalStatus[key]
        )
    );
  };

  // Zone manager verification of a sub point - the same call, a third column
  toggleSubPointZoneApproval = (planDtlId, subPointIndex) => {
    const {
      subPointZoneApprovalStatus,
      subPointHallApprovalStatus,
      subPointApprovalStatus,
    } = this.state;
    const key = planDtlId + "_" + subPointIndex;

    if (
      !this.canSetZoneApproval(
        !!subPointHallApprovalStatus[key],
        !!subPointApprovalStatus[key]
      )
    ) {
      if (this.state.isZoneManager) {
        toastError(this.zoneLockedMessage(!!subPointApprovalStatus[key]));
      }
      return;
    }

    this.setState(
      {
        subPointZoneApprovalStatus: {
          ...subPointZoneApprovalStatus,
          [key]: !subPointZoneApprovalStatus[key],
        },
      },
      () =>
        this.updateSubPointApproval(
          planDtlId,
          subPointIndex,
          "IsZoneManagerApprove",
          !subPointZoneApprovalStatus[key]
        )
    );
  };

  updateSubPointApproval = (planDtlId, subPointIndex, field, isApproved) => {
    const ExhVendorPlanHdrID = this.getPlanHdrIDForTask(planDtlId);

    const subPoint = this.groupSubPointsByTask()[planDtlId]?.[subPointIndex];

    if (!subPoint?.ExhVendorPointDtlID) {
      toastError("This sub point cannot be verified yet");
      return;
    }

    // Only the sub point that was clicked goes over, and only the one approval
    // that was clicked - the other stays out so the SP keeps what is stored
    const subTaskDetails = [
      {
        ExhVendorPointDtlID: subPoint.ExhVendorPointDtlID,
        IsCompleted: null,
        [field]: isApproved ? 1 : 0,
        Remark: null,
        ZoneID: this.getZoneIDForTask(planDtlId),
      },
    ];

    this.isTaskUpdateInFlight = true;
    this.props
      .updateVendorTask_action(ExhVendorPlanHdrID, [], subTaskDetails, [])
      .then((data) => {
        if (data.error != 1) {
          toastSuccess("Verification updated successfully!");
          setTimeout(() => {
            this.getVendorTaskList(this.state.filterStatus, true);
            this.isTaskUpdateInFlight = false;
          }, 500);
        } else {
          toastError(data.msg);
          this.isTaskUpdateInFlight = false;
        }
      })
      .catch((err) => {
        console.log(err);
        toastError("Something went wrong!");
        this.isTaskUpdateInFlight = false;
      });
  };

  // One remark thread per task row, one more per sub point of that task
  getTaskRemarkKey = (planDtlId) => `task_${planDtlId}`;

  getSubPointRemarkKey = (planDtlId, spIndex) =>
    `task_${planDtlId}_sub_${spIndex}`;

  // Remarks come back as their own result set, so pull whichever key of the
  // task response carries that list
  extractRemarkRows(data) {
    if (!data) return [];
    const candidates = [
      data.remarkList,
      data.remarkDetails,
      data.vendorPlanRemarks,
      Array.isArray(data) ? data[1] : null,
    ];
    return candidates.find((list) => Array.isArray(list)) || [];
  }

  // One API row is one posted message. The result set used to carry the task's
  // latest text and a log row's text side by side under Remark / RemarkSub, which
  // is why a row could expand into two messages - it no longer does, but a row in
  // the old shape is still read so the screen works against either version
  normalizeRemarkRow(row) {
    const authorId = row.UserID ?? row.LastUpdatedBy ?? null;

    const base = {
      RemarkID: row.RemarkID ?? null,
      ExhVendorPlanDtlID: row.ExhVendorPlanDtlID,
      ExhVendorPointDtlID: row.ExhVendorPointDtlID ?? null,
      // A 0 or an empty string is not a usable id, don't let it beat the name
      LastUpdatedBy: authorId === 0 || authorId === "" ? null : authorId,
      // Can arrive as blank or a lone space, treat that as no name at all
      PersonName: String(row.UserName ?? row.PersonName ?? "").trim(),
      Designation: row.Role ?? row.Designation ?? "",
      LastUpdatedDate: row.UpdateTime ?? row.LastUpdatedDate ?? null,
    };

    const taskText = row.Remark && String(row.Remark).trim();
    const subPointText = row.RemarkSub && String(row.RemarkSub).trim();

    // The API says which thread the message belongs to. Falling back to the point
    // id keeps rows in the old shape readable
    const isSubPoint =
      row.IsSubPoint != null
        ? row.IsSubPoint === true || row.IsSubPoint === 1
        : row.ExhVendorPointDtlID != null;

    const messages = [];
    if (taskText) {
      messages.push({ ...base, Remark: taskText, isSubPoint });
    }
    if (subPointText && subPointText !== taskText) {
      messages.push({
        ...base,
        Remark: subPointText,
        isSubPoint: row.ExhVendorPointDtlID != null,
      });
    }

    return messages;
  }

  // Flat remark rows get matched to their thread by ExhVendorPointDtlID for a
  // sub point message and ExhVendorPlanDtlID for a task one
  buildRemarkThreads(vendorPlanList, remarkRows = this.state.remarkSource) {
    const threads = {};
    const subPointsByTask = this.groupSubPointsByTask(vendorPlanList);

    const keyByPointDtlId = {};
    Object.keys(subPointsByTask).forEach((planDtlId) => {
      subPointsByTask[planDtlId].forEach((sp, spIndex) => {
        if (sp.ExhVendorPointDtlID != null) {
          keyByPointDtlId[sp.ExhVendorPointDtlID] = this.getSubPointRemarkKey(
            planDtlId,
            spIndex
          );
        }
      });
    });

    const knownTaskIds = new Set(
      (vendorPlanList || []).map((task) => String(task.ExhVendorPlanDtlID))
    );

    let unresolved = 0;

    const placeMessage = (remark) => {
      let key = null;

      if (remark.isSubPoint) {
        // Better to leave it out than to show it under the wrong sub point
        key = keyByPointDtlId[remark.ExhVendorPointDtlID] || null;
      } else if (knownTaskIds.has(String(remark.ExhVendorPlanDtlID))) {
        key = this.getTaskRemarkKey(remark.ExhVendorPlanDtlID);
      }

      if (!key) {
        unresolved++;
        return;
      }

      if (!threads[key]) threads[key] = [];

      // Every message now carries its own RemarkID, so two people posting the same
      // words both show. Only a row in the old shape, which has no id, still has to
      // fall back to the text
      const alreadyAdded = threads[key].some((r) =>
        remark.RemarkID != null
          ? r.RemarkID === remark.RemarkID
          : r.RemarkID == null && r.Remark === remark.Remark
      );
      if (!alreadyAdded) threads[key].push({ ...remark });
    };

    (remarkRows || []).forEach((row) =>
      this.normalizeRemarkRow(row).forEach(placeMessage)
    );

    if (unresolved > 0) {
      console.warn(
        `[remark] ${unresolved} remark(s) dropped - ExhVendorPlanDtlID / ExhVendorPointDtlID on the row match no task or sub point in the list`
      );
    }

    // Anything not saved yet has to survive a background refresh
    const currentThreads = this.state.remarkDetails || {};
    Object.keys(currentThreads).forEach((key) => {
      const pending = currentThreads[key].filter((r) => r.isPending);
      if (pending.length > 0) {
        threads[key] = [...(threads[key] || []), ...pending];
      }
    });


    // Oldest first so the thread reads like a chat. Read the same way it is
    // printed, otherwise a message that has not been saved yet - which carries no
    // zone marker - sorts against the saved ones by a different clock
    Object.keys(threads).forEach((key) => {
      threads[key].sort(
        (a, b) =>
          serverDateTimeValue(a.LastUpdatedDate) -
          serverDateTimeValue(b.LastUpdatedDate)
      );
    });

    return threads;
  }

  // Letters and digits only, so spacing, case and punctuation differences don't
  // decide who wrote a message
  normalizeName = (value) =>
    String(value ?? "").toLowerCase().replace(/[^a-z0-9]/g, "");

  // The remark result set carries UserName but no id, so own messages are found
  // by matching that name against every identity the session can offer
  getOwnIdentities() {
    const loginData = JSON.parse(sessionStorage.getItem("loginDataSS")) || {};
    const first =
      loginData.FirstName || sessionStorage.getItem("firstNameSS") || "";
    const last =
      loginData.LastName || sessionStorage.getItem("lastNameSS") || "";

    return new Set(
      [
        loginData.UserName,
        loginData.Name,
        loginData.FullName,
        loginData.PersonName,
        loginData.EmailID,
        loginData.Email,
        sessionStorage.getItem("userEmailSS"),
        `${first} ${last}`,
        `${last} ${first}`,
      ]
        .map(this.normalizeName)
        .filter((value) => value.length > 0)
    );
  }

  openRemarkModal = (planDtlId, spIndex, pointDtlId, title) => {
    this.setState({
      showRemarkModal: true,
      activeRemarkKey:
        spIndex == null
          ? this.getTaskRemarkKey(planDtlId)
          : this.getSubPointRemarkKey(planDtlId, spIndex),
      activeRemarkTitle: title,
      activeRemarkTarget: {
        ExhVendorPlanDtlID: planDtlId,
        ExhVendorPointDtlID: spIndex == null ? null : pointDtlId,
        spIndex,
      },
      newRemark: "",
    });
  };

  closeRemarkModal = () => {
    this.setState({
      showRemarkModal: false,
      activeRemarkKey: null,
      activeRemarkTitle: "",
      activeRemarkTarget: null,
      newRemark: "",
    });
  };

  // Everybody who can open the task list can post. This screen has no plan wide
  // save, so the message is shown straight away and sent on its own
  addRemark = () => {
    const { newRemark, activeRemarkKey, activeRemarkTarget, remarkDetails } =
      this.state;
    const text = (newRemark || "").trim();

    if (!text) {
      toastError("Please enter a note/remark");
      return;
    }

    if (
      activeRemarkTarget?.spIndex != null &&
      activeRemarkTarget.ExhVendorPointDtlID == null
    ) {
      toastError("This sub point cannot take a note/remark yet");
      return;
    }

    const loginData = JSON.parse(sessionStorage.getItem("loginDataSS"));
    const entry = {
      Remark: text,
      LastUpdatedBy: loginData.UserID,
      PersonName: [loginData.FirstName, loginData.LastName]
        .filter(Boolean)
        .join(" "),
      LastUpdatedDate: moment().utcOffset("+05:30").format("YYYY-MM-DD HH:mm:ss"),
      isPending: true,
    };

    this.setState(
      {
        remarkDetails: {
          ...remarkDetails,
          [activeRemarkKey]: [...(remarkDetails[activeRemarkKey] || []), entry],
        },
        newRemark: "",
      },
      () => {
        this.scrollRemarkThreadToBottom();
        this.saveRemark(text, activeRemarkKey, activeRemarkTarget);
      }
    );
  };

  // The list holds deliverables from every plan header at once, but a save carries
  // only one header, so it has to be the header of the row being acted on. Sending
  // the first listed row's header meant a save against any other one was scoped to
  // the wrong plan
  getPlanHdrIDForTask = (planDtlId) => {
    const { vendorPlanList } = this.state;
    const task = vendorPlanList.find(
      (t) => t.ExhVendorPlanDtlID === planDtlId
    );
    return task?.ExhVendorPlanHdrID ?? vendorPlanList[0]?.ExhVendorPlanHdrID ?? null;
  };

  // sp_get_ExhVendorTaskDetails already resolves each deliverable's zone
  // (MstHallZoneMapping.HallZoneMappingID) - carried here so every notification
  // this screen raises (complete, verify, remark, attachment) can scope its
  // audience to that zone instead of the whole hall. A sub point has no zone of
  // its own, so it is always looked up by its parent task's id
  getZoneIDForTask = (planDtlId) => {
    const { vendorPlanList } = this.state;
    const task = vendorPlanList.find(
      (t) => t.ExhVendorPlanDtlID === planDtlId
    );
    return task?.ZoneID ?? null;
  };

  // A message changes nothing but itself. Only the row being remarked is sent, and
  // it carries IsCompleted: null so the SP keeps whatever tick is stored - this
  // screen is open in several places at once and used to push a whole set of
  // completion values it had read seconds earlier back over everyone else's work
  saveRemark = (text, key, target) => {
    const ExhVendorPlanHdrID = this.getPlanHdrIDForTask(
      target.ExhVendorPlanDtlID
    );

    const isSubPointRemark = target.ExhVendorPointDtlID != null;
    const zoneID = this.getZoneIDForTask(target.ExhVendorPlanDtlID);

    const taskDetails = isSubPointRemark
      ? []
      : [
        {
          ExhVendorplandtlID: target.ExhVendorPlanDtlID,
          IsCompleted: null,
          Remark: text,
          ZoneID: zoneID,
        },
      ];

    const subTaskDetails = isSubPointRemark
      ? [
        {
          ExhVendorPointDtlID: target.ExhVendorPointDtlID,
          IsCompleted: null,
          Remark: text,
          ZoneID: zoneID,
        },
      ]
      : [];

    // The daily routine rows only exist to mirror a completion, and nothing here
    // completes anything
    const dailyRoutineTaskDetails = [];

    this.isTaskUpdateInFlight = true;
    this.props
      .updateVendorTask_action(
        ExhVendorPlanHdrID,
        taskDetails,
        subTaskDetails,
        dailyRoutineTaskDetails
      )
      .then((data) => {
        if (data.error != 1) {
          toastSuccess("Notes/Remark added successfully!");
          // The saved copy comes back from the API, drop the local one
          this.setState(
            (prev) => ({
              remarkDetails: {
                ...prev.remarkDetails,
                [key]: (prev.remarkDetails[key] || []).filter(
                  (r) => !r.isPending
                ),
              },
            }),
            () => this.getVendorTaskList(this.state.filterStatus, true)
          );
        } else {
          toastError(data.msg);
        }
        this.isTaskUpdateInFlight = false;
      })
      .catch((err) => {
        console.log(err);
        toastError("Something went wrong!");
        this.isTaskUpdateInFlight = false;
      });
  };

  // Remark trigger - stays enabled for every role because the task list is
  // shared and anyone looking at it can comment
  renderRemarkButton(planDtlId, spIndex, pointDtlId, title) {
    const key =
      spIndex == null
        ? this.getTaskRemarkKey(planDtlId)
        : this.getSubPointRemarkKey(planDtlId, spIndex);
    const count = (this.state.remarkDetails[key] || []).length;

    return (
      <button
        type="button"
        className="btn btn-sm btn-aqua-border mt-1"
        onClick={(e) => {
          e.stopPropagation();
          this.openRemarkModal(planDtlId, spIndex, pointDtlId, title);
        }}
        style={{
          padding: "0.25rem 0.5rem",
          fontSize: "0.7rem",
          whiteSpace: "nowrap",
        }}
        title="Notes/Remark"
      >
        <i className="ri-message-3-line"></i>
        <span className="ms-1">Notes/Remark{count > 0 ? ` (${count})` : ""}</span>
      </button>
    );
  }

  // Same chat layout as the Hall Manager work updation remark popup -
  // own messages on the right, everyone else's on the left
  // The API sends the role as "Vendor", but that party is called the Service
  // Partner everywhere on screen. Only the printed text changes - the raw value
  // still decides whose message it is
  displayDesignation = (designation) =>
    String(designation ?? "").replace(/\bvendor\b/gi, "Service Partner");

  renderRemarkThread(remarks) {
    const loginData = JSON.parse(sessionStorage.getItem("loginDataSS"));
    const currentUserID = loginData.UserID;
    const currentRole = this.normalizeName(loginData.RoleName);
    const ownIdentities = this.getOwnIdentities();

    // Any of the three is enough. The id is exact and rides on messages added in
    // this session, the name covers what the API returns, and the signed in role
    // matched against the remark's Role catches the rest
    const isOwnRemark = (item) =>
      (item.LastUpdatedBy != null && item.LastUpdatedBy == currentUserID) ||
      ownIdentities.has(this.normalizeName(item.PersonName)) ||
      (!!currentRole && this.normalizeName(item.Designation) === currentRole);

    return (
      <div
        className="chat-box"
        ref={(el) => (this.remarkThreadRef = el)}
        style={{
          maxHeight: 400,
          overflowY: "auto",
          display: "flex",
          flexDirection: "column",
          gap: 8,
        }}
      >
        {remarks.map((item, index) => {
          const isOwn = isOwnRemark(item);

          return (
            <div
              key={index}
              className={`message ${isOwn ? "outgoing" : "incoming"}`}
              style={{
                alignSelf: isOwn ? "flex-end" : "flex-start",
                maxWidth: "80%",
                textAlign: isOwn ? "right" : "left",
              }}
            >
              <div
                className="meta"
                style={{ fontSize: 12, color: "#6b7280", marginBottom: 4 }}
              >
                {isOwn
                  ? "You"
                  : `${item.PersonName || "-"}${item.Designation
                    ? ` (${this.displayDesignation(item.Designation)})`
                    : ""
                  }`}{" "}
                •{" "}
                {formatServerDateTime(item.LastUpdatedDate)}
                {item.isPending && (
                  <span className="text-danger"> • Not saved yet</span>
                )}
              </div>

              <div
                className="bubble"
                style={{
                  background: isOwn ? "#e8f6f4" : "#fff",
                  borderRadius: "12px 12px 4px 12px",
                  padding: "8px 16px",
                  fontSize: 14,
                  border: "1px solid #e5e7eb",
                  whiteSpace: "pre-wrap",
                }}
              >
                {item.Remark}
              </div>
            </div>
          );
        })}
      </div>
    );
  }

  // A long thread opens at the top, which hides the newest message - the one the
  // user came to read
  scrollRemarkThreadToBottom = () => {
    const thread = this.remarkThreadRef;
    if (thread) thread.scrollTop = thread.scrollHeight;
  };

  // react-modal parks focus on the dialog itself when it opens, so the box has
  // to be focused after that has happened - the timeout puts this at the end of
  // the same tick, otherwise react-modal's own focus call lands last and the
  // user has to click before typing
  onRemarkModalOpen = () => {
    setTimeout(() => {
      if (this.remarkInputRef) {
        this.remarkInputRef.style.setProperty("overflow-y", "auto", "important");
        this.remarkInputRef.style.setProperty("height", "80px", "important");
        this.remarkInputRef.focus();
      }
      this.scrollRemarkThreadToBottom();
    }, 0);
  };

  renderRemarkModal() {
    const {
      showRemarkModal,
      activeRemarkKey,
      activeRemarkTitle,
      newRemark,
      remarkDetails,
    } = this.state;

    const remarks = remarkDetails[activeRemarkKey] || [];

    return (
      <Modal
        isOpen={showRemarkModal}
        onRequestClose={this.closeRemarkModal}
        onAfterOpen={this.onRemarkModalOpen}
        ariaHideApp={false}
      >
        <div className="modal-dialog modal-lg">
          <div className="modal-content">
            <div className="modal-header py-3 text-white">
              <h6 className="mb-0">Notes/Remark</h6>
              <button
                type="button"
                className="btn-close ms-auto"
                onClick={this.closeRemarkModal}
              ></button>
            </div>

            <div className="modal-body" style={{ background: "#f9fafb" }}>
              {activeRemarkTitle && (
                <p className="mb-3">{activeRemarkTitle}</p>
              )}
              {remarks.length > 0 ? (
                this.renderRemarkThread(remarks)
              ) : (
                <div className="text-left">Record not found</div>
              )}
              <div className="mt-3">
                <textarea
                  ref={(el) => (this.remarkInputRef = el)}
                  className="form-control flex-grow-1 remark-textarea"
                  rows={3}
                  maxLength={500}
                  placeholder="Type a note/remark..."
                  value={newRemark}
                  onChange={(e) => this.setState({ newRemark: e.target.value })}
                  onKeyDown={(e) => {
                    if (e.key === "Enter" && !e.shiftKey) {
                      e.preventDefault();
                      this.addRemark();
                    }
                  }}
                  style={{
                    height: "80px",
                    minHeight: "75px",
                    overflowY: "auto",
                    resize: "vertical",
                  }}
                />
              </div>
            </div>

            <div className="modal-footer p-2">
              <div className="d-flex align-items-end gap-2">
                {/* No form-control-sm here - custom.css pins that class to a
                    130px wide box, which leaves nothing to type in */}

                <button
                  type="button"
                  className="btn btn-aqua"
                  onClick={this.addRemark}
                >
                  Send
                </button>
                <button
                  type="button"
                  className="btn btn-gray"
                  onClick={this.closeRemarkModal}
                >
                  Close
                </button>
              </div>
            </div>
          </div>
        </div>
      </Modal>
    );
  }

  // Attachments hang off the same task / sub point threads as remarks, so they
  // are keyed the same way. A stored attachment is matched to its thread by
  // ExhVendorPointDtlID for a sub point and ExhVendorPlanDtlID for a task
  buildAttachmentMap(vendorPlanList, attachmentRows) {
    const attachments = {};
    const subPointsByTask = this.groupSubPointsByTask(vendorPlanList);

    const keyByPointDtlId = {};
    Object.keys(subPointsByTask).forEach((planDtlId) => {
      subPointsByTask[planDtlId].forEach((sp, spIndex) => {
        if (sp.ExhVendorPointDtlID != null) {
          keyByPointDtlId[sp.ExhVendorPointDtlID] = this.getSubPointRemarkKey(
            planDtlId,
            spIndex
          );
        }
      });
    });

    const knownTaskIds = new Set(
      (vendorPlanList || []).map((task) => String(task.ExhVendorPlanDtlID))
    );

    let unresolved = 0;

    (attachmentRows || []).forEach((row) => {
      const attachment = normalizeAttachmentRow(row);
      let key = null;

      if (attachment.ExhVendorPointDtlID != null) {
        // Better to leave it out than to show it under the wrong sub point
        key = keyByPointDtlId[attachment.ExhVendorPointDtlID] || null;
      } else if (knownTaskIds.has(String(attachment.ExhVendorPlanDtlID))) {
        key = this.getTaskRemarkKey(attachment.ExhVendorPlanDtlID);
      }

      if (!key) {
        unresolved++;
        return;
      }

      if (!attachments[key]) attachments[key] = [];
      attachments[key].push(attachment);
    });

    if (unresolved > 0) {
      console.warn(
        `[attachment] ${unresolved} attachment(s) dropped - ExhVendorPlanDtlID / ExhVendorPointDtlID on the row match no task or sub point in the list`
      );
    }

    // Two slots per task / sub point, whatever is stored beyond them stays hidden
    Object.keys(attachments).forEach((key) => {
      attachments[key] = capAttachments(attachments[key]);
    });

    return attachments;
  }

  openAttachmentModal = (planDtlId, spIndex, pointDtlId, title) => {
    this.setState({
      showAttachmentModal: true,
      activeAttachmentKey:
        spIndex == null
          ? this.getTaskRemarkKey(planDtlId)
          : this.getSubPointRemarkKey(planDtlId, spIndex),
      activeAttachmentTitle: title,
      activeAttachmentTarget: {
        ExhVendorPlanDtlID: planDtlId,
        ExhVendorPointDtlID: spIndex == null ? null : pointDtlId,
        spIndex,
      },
    });
  };

  closeAttachmentModal = () => {
    this.setState({
      showAttachmentModal: false,
      activeAttachmentKey: null,
      activeAttachmentTitle: "",
      activeAttachmentTarget: null,
    });
  };

  // This screen has no plan wide save, so a file is sent on its own the moment
  // it is picked - the same way a remark is
  handleAttachmentPick = async (e) => {
    const { activeAttachmentKey, activeAttachmentTarget, attachmentDetails } =
      this.state;
    const input = e.target;
    const file = input.files?.[0];

    if (!file) return;
    input.value = "";

    const current = attachmentDetails[activeAttachmentKey] || [];

    if (current.length >= MAX_ATTACHMENTS) {
      toastError(
        `Only ${MAX_ATTACHMENTS} attachments are allowed - remove one to add another`
      );
      return;
    }

    if (
      activeAttachmentTarget?.spIndex != null &&
      activeAttachmentTarget.ExhVendorPointDtlID == null
    ) {
      toastError("This sub point cannot take an attachment yet");
      return;
    }

    const picked = await pickAttachmentFile(file);
    if (!picked) return;

    this.saveAttachment(
      {
        ExhPlanAttachmentDtlID: null,
        ExhVendorPlanDtlID: activeAttachmentTarget.ExhVendorPlanDtlID,
        ExhVendorPointDtlID: activeAttachmentTarget.ExhVendorPointDtlID,
        AttachmentFilePath: picked.AttachmentFilePath,
        FileName: picked.FileName,
        FileType: picked.FileType,
        IsActive: 1,
        ActionID: ATTACHMENT_ACTION_ADD,
        ZoneID: this.getZoneIDForTask(activeAttachmentTarget.ExhVendorPlanDtlID),
      },
      "Attachment uploaded successfully!"
    );
  };

  removeAttachment = (index) => {
    const { activeAttachmentKey, activeAttachmentTarget, attachmentDetails } =
      this.state;
    const attachment = (attachmentDetails[activeAttachmentKey] || [])[index];

    if (!attachment) return;

    this.saveAttachment(
      {
        ExhPlanAttachmentDtlID: attachment.ExhPlanAttachmentDtlID,
        ExhVendorPlanDtlID:
          attachment.ExhVendorPlanDtlID ??
          activeAttachmentTarget?.ExhVendorPlanDtlID ??
          null,
        ExhVendorPointDtlID:
          attachment.ExhVendorPointDtlID ??
          activeAttachmentTarget?.ExhVendorPointDtlID ??
          null,
        AttachmentFilePath: attachment.AttachmentFilePath,
        FileName: attachment.FileName,
        FileType: attachment.FileType,
        IsActive: 0,
        ActionID: ATTACHMENT_ACTION_REMOVE,
      },
      "Attachment removed successfully!"
    );
  };

  // Goes through the same call as a completion, but carries the file and nothing
  // else. Sending the completion set alongside it would push ticks read seconds
  // ago back over whatever another user changed in the meantime
  saveAttachment = (attachmentRow, successMessage) => {
    const ExhVendorPlanHdrID = this.getPlanHdrIDForTask(
      attachmentRow.ExhVendorPlanDtlID
    );

    this.setState({ isLoading: true });
    this.isTaskUpdateInFlight = true;

    this.props
      .updateVendorTask_action(
        ExhVendorPlanHdrID,
        [],
        [],
        [],
        [attachmentRow]
      )
      .then((data) => {
        this.setState({ isLoading: false });
        if (data.error != 1) {
          toastSuccess(successMessage);
          this.getVendorTaskList(this.state.filterStatus, true);
        } else {
          toastError(data.msg);
        }
        this.isTaskUpdateInFlight = false;
      })
      .catch((err) => {
        console.log(err);
        this.setState({ isLoading: false });
        toastError("Something went wrong!");
        this.isTaskUpdateInFlight = false;
      });
  };

  // Attachment trigger - the count tells the user how many of the two slots are
  // taken without having to open the popup
  renderAttachmentButton(planDtlId, spIndex, pointDtlId, title) {
    const key =
      spIndex == null
        ? this.getTaskRemarkKey(planDtlId)
        : this.getSubPointRemarkKey(planDtlId, spIndex);
    const count = (this.state.attachmentDetails[key] || []).length;

    return (
      <button
        type="button"
        className="btn btn-sm btn-aqua-border mt-1"
        onClick={(e) => {
          e.stopPropagation();
          this.openAttachmentModal(planDtlId, spIndex, pointDtlId, title);
        }}
        style={{
          padding: "0.25rem 0.5rem",
          fontSize: "0.7rem",
          whiteSpace: "nowrap",
        }}
        title="Attachments"
      >
        <i className="ri-attachment-2"></i>
        <span className="ms-1">
          Attach{count > 0 ? ` (${count}/${MAX_ATTACHMENTS})` : ""}
        </span>
      </button>
    );
  }

  renderAttachmentModal() {
    const {
      showAttachmentModal,
      activeAttachmentKey,
      activeAttachmentTitle,
      attachmentDetails,
    } = this.state;

    const attachments = attachmentDetails[activeAttachmentKey] || [];
    const canAdd = attachments.length < MAX_ATTACHMENTS;

    return (
      <Modal
        isOpen={showAttachmentModal}
        onRequestClose={this.closeAttachmentModal}
        ariaHideApp={false}
      >
        <div className="modal-dialog modal-lg">
          <div className="modal-content">
            <div className="modal-header py-3 text-white">
              <h6 className="mb-0">Attachments</h6>
              <button
                type="button"
                className="btn-close ms-auto"
                onClick={this.closeAttachmentModal}
              ></button>
            </div>

            <div className="modal-body" style={{ background: "#f9fafb" }}>
              {activeAttachmentTitle && (
                <p className="mb-3">{activeAttachmentTitle}</p>
              )}

              {attachments.length > 0 ? (
                attachments.map((attachment, index) => (
                  <div
                    key={attachment.ExhPlanAttachmentDtlID || index}
                    className="d-flex align-items-center justify-content-between bg-white border rounded p-2 mb-2"
                  >
                    <div className="d-flex flex-column text-break">
                      <div className="d-flex align-items-center gap-2">
                        <i className="ri-file-line"></i>
                        <span style={{ fontSize: 14 }}>
                          {getAttachmentName(attachment)}
                        </span>
                      </div>
                      {/* Anyone on this screen can upload, so the thread has to
                          say who put the file there */}
                      {(attachment.UploadedByName ||
                        attachment.UploadedDate) && (
                          <span style={{ fontSize: 12, color: "#6b7280" }}>
                            {attachment.UploadedByName || "-"}
                            {attachment.UploadedDate
                              ? ` • ${formatServerDateTime(
                                attachment.UploadedDate
                              )}`
                              : ""}
                          </span>
                        )}
                    </div>
                    <div className="d-flex align-items-center gap-2">
                      <button
                        type="button"
                        className="btn btn-sm btn-aqua-border"
                        onClick={() =>
                          window.open(
                            getAttachmentUrl(attachment.AttachmentFilePath),
                            "_blank"
                          )
                        }
                        title="View"
                      >
                        <i className="ri-eye-line"></i>
                      </button>
                      <button
                        type="button"
                        className="btn btn-sm btn-aqua"
                        onClick={() => this.removeAttachment(index)}
                        title="Remove"
                      >
                        <i className="ri-delete-bin-line"></i>
                      </button>
                    </div>
                  </div>
                ))
              ) : (
                <p className="text-left">No attachment added</p>
              )}

              <p className=" mt-1 mb-0">
                Up to {MAX_ATTACHMENTS} attachments (.pdf, .jpg, .jpeg, .png -
                max 5 MB each). Remove one to add another.
              </p>
            </div>

            <div className="modal-footer p-2">
              {canAdd && (
                <button
                  className="btn btn-aqua mb-0"
                  style={{ cursor: "pointer" }}
                >
                  <i className="ri-upload-2-line me-1"></i>
                  Upload
                  <input
                    type="file"
                    accept=".pdf,.jpg,.jpeg,.png"
                    hidden
                    onChange={this.handleAttachmentPick}
                  />
                </button>
              )}
              <button
                type="button"
                className="btn btn-gray"
                onClick={this.closeAttachmentModal}
              >
                Close
              </button>
            </div>
          </div>
        </div>
      </Modal>
    );
  }

  getFilteredTasks = () => {
    const {
      vendorPlanList,
      filterStatus,
      selectedHall,
      selectedZone,
      selectedService,
      selectedVendor,
    } = this.state;

    let filtered = vendorPlanList;

    if (selectedVendor) {
      filtered = filtered.filter(
        (task) => task.CompanyName === selectedVendor.value,
      );
    }

    if (selectedHall) {
      filtered = filtered.filter(
        (task) => task.HallName === selectedHall.value,
      );
    }

    if (selectedZone) {
      filtered = filtered.filter(
        (task) => task.ZoneName === selectedZone.value,
      );
    }

    if (selectedService) {
      filtered = filtered.filter(
        (task) => task.ServiceName === selectedService.value,
      );
    }

    // Deduplicate tasks by ExhVendorPlanDtlID to avoid showing same task multiple times
    const uniqueTasks = {};
    filtered.forEach((task) => {
      if (!uniqueTasks[task.ExhVendorPlanDtlID]) {
        uniqueTasks[task.ExhVendorPlanDtlID] = task;
      }
    });

    return Object.values(uniqueTasks);
  };

  getTaskCounts = () => {
    return this.state.taskCounts;
  };

  renderFilterButtons = () => {
    const {
      filterStatus,
      vendorPlanList,
      selectedHall,
      selectedZone,
      selectedService,
      selectedVendor,
      isVendor,
    } = this.state;
    const counts = this.getTaskCounts();

    const vendorOptions = [
      ...new Set(vendorPlanList.map((task) => task.CompanyName)),
    ]
      .filter(Boolean)
      .map((vendor) => ({ value: vendor, label: vendor }));

    const hallOptions = [
      ...new Set(vendorPlanList.map((task) => task.HallName)),
    ]
      .filter(Boolean)
      .map((hall) => ({ value: hall, label: hall }));

    const zoneOptions = [
      ...new Set(vendorPlanList.map((task) => task.ZoneName)),
    ]
      .filter(Boolean)
      .map((zone) => ({ value: zone, label: zone }));

    const serviceOptions = [
      ...new Set(vendorPlanList.map((task) => task.ServiceName)),
    ]
      .filter(Boolean)
      .map((service) => ({ value: service, label: service }));

    return (
      <div className="mx-2 pt-2 vendor-task-filter-container">
        <div className="d-flex flex-wrap align-items-center gap-2 mb-2">
          {!isVendor && (
            <div className="filter-select-item">
              <Select
                value={selectedVendor}
                onChange={(option) => this.setState({ selectedVendor: option })}
                options={vendorOptions}
                placeholder="Search by Service Partner"
                isClearable
                className="vendor-select-field"
                classNamePrefix="select"
                styles={{ container: (base) => ({ ...base, minWidth: "180px" }) }}
              />
            </div>
          )}

          <div className="filter-select-item">
            <Select
              value={selectedHall}
              onChange={(option) => this.setState({ selectedHall: option })}
              options={hallOptions}
              placeholder="Search by Hall / Location"
              isClearable
              className="vendor-select-field"
              classNamePrefix="select"
              styles={{ container: (base) => ({ ...base, minWidth: "180px" }) }}
            />
          </div>

          <div className="filter-select-item">
            <Select
              value={selectedZone}
              onChange={(option) => this.setState({ selectedZone: option })}
              options={zoneOptions}
              placeholder="Search by Zone"
              isClearable
              className="vendor-select-field"
              classNamePrefix="select"
              styles={{ container: (base) => ({ ...base, minWidth: "180px" }) }}
            />
          </div>

          <div className="filter-select-item">
            <Select
              value={selectedService}
              onChange={(option) => this.setState({ selectedService: option })}
              options={serviceOptions}
              placeholder="Search by Service"
              isClearable
              className="vendor-select-field"
              classNamePrefix="select"
              styles={{ container: (base) => ({ ...base, minWidth: "180px" }) }}
            />
          </div>
        </div>

        <div className="d-flex flex-wrap align-items-center gap-2 mb-2">
          {/* Overdue */}
          <button
            className={`btn d-flex align-items-center justify-content-between btn-status border ${filterStatus === "overdue" ? "active" : ""
              }`}
            onClick={() => this.setFilter("overdue")}
          >
            <span>Overdue By Service Partner</span>
            <span className="badge badge-status ms-2">{counts.overdue}</span>
          </button>

          {/* Pending */}
          <button
            className={`btn d-flex align-items-center justify-content-between btn-status border ${filterStatus === "pending" ? "active" : ""
              }`}
            onClick={() => this.setFilter("pending")}
          >
            <span>Pending By Service Partner</span>
            <span className="badge badge-status ms-2">{counts.pending}</span>
          </button>

          {/* Completed */}
          <button
            className={`btn d-flex align-items-center justify-content-between btn-status border ${filterStatus === "completed" ? "active" : ""
              }`}
            onClick={() => this.setFilter("completed")}
          >
            <span>Service Partner Completed-Hall Manager Pending</span>
            <span className="badge badge-status ms-2">{counts.completed}</span>
          </button>

          <button
            className={`btn d-flex align-items-center justify-content-between btn-status border ${filterStatus === "hallcompleted" ? "active" : ""
              }`}
            onClick={() => this.setFilter("hallcompleted")}
          >
            <span>Service Partner Completed-Hall Manager Completed</span>
            <span className="badge badge-status ms-2">
              {counts.hallCompleted}
            </span>
          </button>

          <div className="d-flex align-items-center gap-2 vendor-task-actions">
            {/* Download Excel Button */}
            <button
              className="btn btn-aqua d-flex align-items-center"
              onClick={this.downloadExcel}
              title="Download Completed Tasks"
            >
              <i className="bi bi-download me-2"></i>
              Excel
            </button>

            {filterStatus !== "all" && (
              <button
                className="btn btn-aqua px-3"
                onClick={() => this.setFilter("all")}
              >
                Show All
              </button>
            )}
          </div>
        </div>
      </div>
    );
  };

  renderDirectTaskTable() {
    const {
      isVendor,
      isAdmin,
      isHallManager,
      subPointCompletionStatus,
      subPointApprovalStatus,
      subPointHallApprovalStatus,
      subPointZoneApprovalStatus,
      isZoneManager,
    } = this.state;
    const filteredTasks = this.getFilteredTasks();
    const subPointsByTask = this.groupSubPointsByTask();

    const formatDateTime = (dateString) => {
      if (!dateString || dateString === null || dateString === "") return "NA";
      const date = new Date(dateString);
      return date
        .toLocaleString("en-GB", {
          day: "2-digit",
          month: "2-digit",
          year: "numeric",
          hour: "2-digit",
          minute: "2-digit",
        })
        .replace(",", "");
    };

    // CompletionDateTime is a real datetime column, so it goes through the reading
    // that does not shift it. The legacy value is a string the SP already
    // formatted, and is only there for rows ticked before that column existed
    const completedOn = (isCompleted, completionDateTime, legacyText) => {
      if (!isCompleted) return "-";
      if (completionDateTime) return formatServerDateTime(completionDateTime);
      return legacyText || "-";
    };

    // A locked row keeps the tick on screen so its state still reads, but the
    // pointer and the padlock say up front that clicking it will be refused.
    // The completion stamp sits under the label rather than in a column of its
    // own, the same way the two verification stamps do
    const getStatusDisplay = (task) => {
      const statusText = task.Overdue
        ? "Overdue"
        : task.IsCompleted
          ? "Completed"
          : "Pending";
      const isLocked = this.isTaskLocked(task);
      const lockTitle = isLocked
        ? this.lockedMessage(this.isFlagOn(task.IsAdminApprove))
        : "";
      const completedText = completedOn(
        task.IsCompleted,
        task.CompletionDateTime,
        task.CompletedDateTime
      );

      return (
        <div className="text-center" title={lockTitle}>
          <div className="d-flex align-items-center justify-content-center">
            <div
              className="rounded-circle d-inline-flex align-items-center justify-content-center me-2 border"
              style={{
                width: "10px",
                height: "10px",
                cursor: isLocked ? "not-allowed" : "pointer",
                marginRight: "8px",
                backgroundColor: task.IsCompleted ? "#3dbca7" : "",
                borderColor: "#3dbca7",
                opacity: isLocked ? 0.5 : 1,
              }}
              onClick={() => this.toggleTaskCompletion(task.ExhVendorPlanDtlID)}
            >
              {task.IsCompleted && (
                <i
                  className="fa fa-check text-white"
                  style={{ fontSize: "12px" }}
                ></i>
              )}
            </div>
            <span className="d-flex align-items-center">
              <span
                className="badge rounded-circle me-2"
                style={{
                  width: "12px",
                  height: "12px",
                  backgroundColor: "#3dbca7",
                }}
              ></span>
              <span>{statusText}</span>
            </span>
            {isLocked && (
              <i
                className="ri-lock-line ms-2"
                style={{ fontSize: "13px", color: "#6c757d" }}
              ></i>
            )}
            {task.Overdue && (
              <span
                style={{ fontSize: "13px", marginLeft: "8px" }}
              >
                ({task.Overdue})
              </span>
            )}
          </div>
          {task.IsCompleted && completedText !== "-" && (
            <div
              style={{
                fontSize: "11px",
                color: "#6b7280",
                whiteSpace: "nowrap",
              }}
            >
              {completedText}
            </div>
          )}
        </div>
      );
    };

    // Same layout as getStatusDisplay so sub point rows line up with the task row
    const getSubPointStatusDisplay = (
      isCompleted,
      planDtlId,
      spIndex,
      completionDateTime = null
    ) => {
      const isLocked = this.isSubPointLocked(planDtlId, spIndex);
      const key = `${planDtlId}_${spIndex}`;
      const task = filteredTasks.find(
        (t) => t.ExhVendorPlanDtlID === planDtlId
      );
      const lockTitle = isLocked
        ? this.lockedMessage(
          !!subPointApprovalStatus[key] ||
          (!!task && this.isFlagOn(task.IsAdminApprove))
        )
        : "";
      const completedText = completedOn(isCompleted, completionDateTime, null);

      return (
        <div className="text-center" title={lockTitle}>
          <div className="d-flex align-items-center justify-content-center">
            <div
              className="rounded-circle d-inline-flex align-items-center justify-content-center me-2 border"
              style={{
                width: "10px",
                height: "10px",
                cursor: isLocked ? "not-allowed" : "pointer",
                marginRight: "8px",
                backgroundColor: isCompleted ? "#3dbca7" : "",
                borderColor: "#3dbca7",
                opacity: isLocked ? 0.5 : 1,
              }}
              onClick={() => this.toggleSubPointCompletion(planDtlId, spIndex)}
            >
              {isCompleted && (
                <i
                  className="fa fa-check text-white"
                  style={{ fontSize: "12px" }}
                ></i>
              )}
            </div>
            <span className="d-flex align-items-center">
              <span
                className="badge rounded-circle me-2"
                style={{
                  width: "12px",
                  height: "12px",
                  backgroundColor: "#3dbca7",
                }}
              ></span>
              <span>
                {isCompleted ? "Completed" : "Pending"}
              </span>
            </span>
            {isLocked && (
              <i
                className="ri-lock-line ms-2"
                style={{ fontSize: "13px", color: "#6c757d" }}
              ></i>
            )}
          </div>
          {isCompleted && completedText !== "-" && (
            <div
              style={{
                fontSize: "11px",
                color: "#6b7280",
                whiteSpace: "nowrap",
              }}
            >
              {completedText}
            </div>
          )}
        </div>
      );
    };

    // Verification reads the same way Status does, so the columns line up. Both
    // verifications are shown to every role - a service partner has to be able to
    // see why the completion tick stopped answering - but only the role that owns
    // the verification, and the organizer, can move it.
    // The stamp sits under the label rather than in a column of its own, so the
    // date stays tied to the tick it belongs to
    const getApprovalDisplay = (
      isApproved,
      onToggle,
      canEdit,
      title = "",
      approvedOn = null
    ) => (
      <div title={title} className="text-center">
        <div className="d-flex align-items-center justify-content-center">
          <div
            className="rounded-circle d-inline-flex align-items-center justify-content-center me-2 border"
            style={{
              width: "10px",
              height: "10px",
              cursor: canEdit ? "pointer" : "not-allowed",
              marginRight: "8px",
              backgroundColor: isApproved ? "#3dbca7" : "",
              borderColor: "#3dbca7",
              opacity: canEdit ? 1 : 0.5,
            }}
            onClick={canEdit ? onToggle : undefined}
          >
            {isApproved && (
              <i
                className="fa fa-check text-white"
                style={{ fontSize: "12px" }}
              ></i>
            )}
          </div>
          <span className="d-flex align-items-center">
            <span
              className="badge rounded-circle me-2"
              style={{ width: "12px", height: "12px", backgroundColor: "#3dbca7" }}
            ></span>
            <span>
              {isApproved ? "Verified" : "Not Verified"}
            </span>
          </span>
        </div>
        {isApproved && approvedOn && (
          <div
            style={{
              fontSize: "11px",
              color: "#6b7280",
              whiteSpace: "nowrap",
            }}
          >
            {/* Not formatDateTime. These two are real datetime columns, so the
                driver hands them over tagged as UTC and new Date() would add the
                offset a second time - 7:30 PM IST printing as 1:00 AM. Same
                reading the remark and attachment timestamps go through */}
            {formatServerDateTime(approvedOn)}
          </div>
        )}
      </div>
    );

    return (
      <div className="w-100">
        <div className="">{this.renderFilterButtons()}</div>
        <div className="row m-0 w-100 px-2">
          <div
            className="table-responsive sticky-table-wrapper border-bottom spt-gridview w-100 p-0"
            style={{ zIndex: "0" }}
          >
            <table className="table sticky-table text-nowrap table-bordered border-bottom border-2 mb-0">
              <thead className="table-light">
                <tr>
                  <th className="text-center col-spt-hall" style={{ width: "250px" }}>
                    Hall / Location
                  </th>
                  <th className="text-center col-spt-zone" style={{ width: "150px" }}>
                    Zone
                  </th>
                  <th className="col-spt-service">Service</th>
                  {!isVendor && <th className="text-left col-spt-partner">Service Partner</th>}
                  <th className="col-spt-deliverables" style={{ width: "1000px" }}>Deliverables</th>
                  <th className="col-spt-date" style={{ width: "20px" }}>Start Date</th>
                  <th className="col-spt-date" style={{ width: "20px" }}>End Date</th>
                  <th className="text-center col-spt-status" style={{ width: "20px" }}>
                    Service Partner Status
                  </th>
                  <th className="text-center col-spt-verify" style={{ width: "20px" }}>
                    Zone Manager Verified
                  </th>
                  <th className="text-center col-spt-verify" style={{ width: "20px" }}>
                    Hall Manager Verified
                  </th>
                  {/* Organizer Verified is no longer a column of its own. A Hall
                      Manager verification writes IsAdminApprove and
                      AdminApprovalDateTime as a copy of its own, so the two
                      always read the same and showing both said nothing twice */}
                </tr>
              </thead>
              <tbody>
                {filteredTasks.length > 0 ? (
                  filteredTasks.map((task, index) => {
                    const hasSubPoints = subPointsByTask[task.ExhVendorPlanDtlID]?.length > 0;

                    return (
                      <Fragment key={task.ExhVendorPlanDtlID || index}>
                        <tr
                          style={{
                            backgroundColor: hasSubPoints ? "#f8f9fa" : "",
                          }}
                        >
                          <td className="text-center col-spt-hall">{task.HallName}</td>
                          <td className="text-center col-spt-zone">{task.ZoneName}</td>
                          <td
                            className="col-spt-service"
                            style={{
                              width: "100px",
                              maxWidth: "100px",
                              wordWrap: "break-word",
                              whiteSpace: "normal",
                            }}
                          >
                            {task.ServiceName}
                          </td>
                          {!isVendor && (
                            <td className="text-left col-spt-partner">
                              <i
                                className="ri-hotel-line company-name-title"
                                style={{ marginRight: "6px", width: "12px" }}
                              ></i>
                              <span className="company-name-title">
                                {task.CompanyName}
                              </span>
                              <br />
                              <i
                                className="fa fa-user"
                                style={{
                                  color: "#6c757d",
                                  marginRight: "6px",
                                  width: "12px",
                                }}
                              ></i>
                              <span>{task.vendorPersonName}</span>
                              <br />
                              <i
                                className="fa fa-envelope"
                                style={{
                                  color: "#6c757d",
                                  marginRight: "6px",
                                  width: "12px",
                                }}
                              ></i>
                              <span>{task.vendorEmail}</span>
                              <br />
                              <i
                                className="fa fa-phone"
                                style={{
                                  color: "#6c757d",
                                  marginRight: "6px",
                                  width: "12px",
                                }}
                              ></i>
                              <span>{task.vendorMobile}</span>
                            </td>
                          )}
                          <td
                            className="col-spt-deliverables"
                            style={{
                              width: "270px",
                              maxWidth: "270px",
                              wordWrap: "break-word",
                              whiteSpace: "normal",
                            }}
                          >
                            <div className="d-flex align-items-start">
                              <span
                                className="fw-bold me-2"
                                style={{ whiteSpace: "nowrap" }}
                              >
                                {index + 1}.
                              </span>
                              <div style={{ fontWeight: "500" }}>
                                {task.DeliverablesServiceName}
                              </div>
                            </div>
                            <div className="d-flex flex-wrap align-items-center gap-2">
                              {this.renderRemarkButton(
                                task.ExhVendorPlanDtlID,
                                null,
                                null,
                                `${index + 1}. ${task.DeliverablesServiceName || ""}`
                              )}
                              {this.renderAttachmentButton(
                                task.ExhVendorPlanDtlID,
                                null,
                                null,
                                `${index + 1}. ${task.DeliverablesServiceName || ""}`
                              )}
                            </div>
                          </td>
                          <td
                            className="col-spt-date"
                            style={{
                              width: "200px",
                              maxWidth: "200px",
                              wordWrap: "break-word",
                              whiteSpace: "normal",
                            }}
                          >
                            {formatDateTime(task.StartTime)}
                          </td>
                          <td
                            className="col-spt-date"
                            style={{
                              width: "200px",
                              maxWidth: "200px",
                              wordWrap: "break-word",
                              whiteSpace: "normal",
                            }}
                          >
                            {formatDateTime(task.EndTime)}
                          </td>
                          <td className="col-spt-status">{getStatusDisplay(task)}</td>
                          <td className="col-spt-verify">
                            {getApprovalDisplay(
                              this.isFlagOn(task.IsZoneManagerApprove),
                              () =>
                                this.toggleTaskZoneApproval(
                                  task.ExhVendorPlanDtlID
                                ),
                              this.canSetZoneApproval(
                                this.isFlagOn(task.IsHallManagerApprove),
                                this.isFlagOn(task.IsAdminApprove)
                              ),
                              isZoneManager &&
                                (this.isFlagOn(task.IsHallManagerApprove) ||
                                  this.isFlagOn(task.IsAdminApprove))
                                ? this.zoneLockedMessage(
                                  this.isFlagOn(task.IsAdminApprove)
                                )
                                : "",
                              task.ZoneManagerApprovalDateTime
                            )}
                          </td>
                          <td className="col-spt-verify">
                            {getApprovalDisplay(
                              this.isFlagOn(task.IsHallManagerApprove),
                              () =>
                                this.toggleTaskHallApproval(
                                  task.ExhVendorPlanDtlID
                                ),
                              this.canSetHallApproval(
                                this.isFlagOn(task.IsAdminApprove)
                              ),
                              isHallManager &&
                                this.isFlagOn(task.IsAdminApprove)
                                ? this.lockedMessage(true)
                                : "",
                              task.HallManagerApprovalDateTime
                            )}
                          </td>

                        </tr>

                        {/* Sub point rows - 1.1, 1.2, ... */}
                        {hasSubPoints &&
                          subPointsByTask[task.ExhVendorPlanDtlID].map(
                            (subPoint, spIndex) => {
                              const isCompleted =
                                subPointCompletionStatus[
                                `${task.ExhVendorPlanDtlID}_${spIndex}`
                                ];
                              const isApproved =
                                subPointApprovalStatus[
                                `${task.ExhVendorPlanDtlID}_${spIndex}`
                                ];
                              const isZoneApproved =
                                subPointZoneApprovalStatus[
                                task.ExhVendorPlanDtlID + "_" + spIndex
                                ];
                              const isHallApproved =
                                subPointHallApprovalStatus[
                                `${task.ExhVendorPlanDtlID}_${spIndex}`
                                ];

                              return (
                                <tr
                                  key={`subpoint_${task.ExhVendorPlanDtlID}_${spIndex}`}
                                  style={{ backgroundColor: "#f4fbfa" }}
                                >
                                  <td className="text-center col-spt-hall">
                                    {task.HallName}
                                  </td>
                                  <td className="text-center col-spt-zone">
                                    {task.ZoneName}
                                  </td>
                                  <td
                                    className="col-spt-service"
                                    style={{
                                      width: "100px",
                                      maxWidth: "100px",
                                      wordWrap: "break-word",
                                      whiteSpace: "normal",
                                    }}
                                  >
                                    {task.ServiceName}
                                  </td>
                                  {!isVendor && <td className="col-spt-partner"></td>}
                                  <td
                                    className="col-spt-deliverables"
                                    style={{
                                      width: "270px",
                                      maxWidth: "270px",
                                      wordWrap: "break-word",
                                      whiteSpace: "normal",
                                    }}
                                  >
                                    <div className="d-flex align-items-start ps-3">
                                      <span
                                        className="fw-bold me-2"
                                        style={{ whiteSpace: "nowrap" }}
                                      >
                                        {index + 1}.{spIndex + 1}
                                      </span>
                                      <span>{subPoint.SubPoint}</span>
                                    </div>
                                    <div className="ps-3 d-flex flex-wrap align-items-center gap-2">
                                      {this.renderRemarkButton(
                                        task.ExhVendorPlanDtlID,
                                        spIndex,
                                        subPoint.ExhVendorPointDtlID,
                                        `${index + 1}.${spIndex + 1} ${subPoint.SubPoint || ""}`
                                      )}
                                      {this.renderAttachmentButton(
                                        task.ExhVendorPlanDtlID,
                                        spIndex,
                                        subPoint.ExhVendorPointDtlID,
                                        `${index + 1}.${spIndex + 1} ${subPoint.SubPoint || ""}`
                                      )}
                                    </div>
                                  </td>
                                  <td
                                    className="col-spt-date"
                                    style={{
                                      width: "200px",
                                      maxWidth: "200px",
                                      wordWrap: "break-word",
                                      whiteSpace: "normal",
                                    }}
                                  >
                                    {formatDateTime(subPoint.StartDateTime)}
                                  </td>
                                  <td
                                    className="col-spt-date"
                                    style={{
                                      width: "200px",
                                      maxWidth: "200px",
                                      wordWrap: "break-word",
                                      whiteSpace: "normal",
                                    }}
                                  >
                                    {formatDateTime(subPoint.EndDateTime)}
                                  </td>
                                  <td className="col-spt-status">
                                    {getSubPointStatusDisplay(
                                      isCompleted,
                                      task.ExhVendorPlanDtlID,
                                      spIndex,
                                      subPoint.CompletionDateTime
                                    )}
                                  </td>
                                  <td className="col-spt-verify">
                                    {getApprovalDisplay(
                                      !!isZoneApproved,
                                      () =>
                                        this.toggleSubPointZoneApproval(
                                          task.ExhVendorPlanDtlID,
                                          spIndex
                                        ),
                                      this.canSetZoneApproval(
                                        !!isHallApproved,
                                        !!isApproved
                                      ),
                                      isZoneManager &&
                                        (isHallApproved || isApproved)
                                        ? this.zoneLockedMessage(!!isApproved)
                                        : "",
                                      subPoint.ZoneManagerApprovalDateTime
                                    )}
                                  </td>
                                  <td className="col-spt-verify">
                                    {getApprovalDisplay(
                                      !!isHallApproved,
                                      () =>
                                        this.toggleSubPointHallApproval(
                                          task.ExhVendorPlanDtlID,
                                          spIndex
                                        ),
                                      this.canSetHallApproval(!!isApproved),
                                      isHallManager && isApproved
                                        ? this.lockedMessage(true)
                                        : "",
                                      subPoint.HallManagerApprovalDateTime
                                    )}
                                  </td>

                                </tr>
                              );
                            }
                          )}
                      </Fragment>
                    );
                  })
                ) : (
                  <tr>
                    <td
                      colSpan={9 + (!isVendor ? 1 : 0)}
                      className="text-center text-muted py-4"
                    >
                      No tasks available
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    );
  }

  toggleTaskCompletion = (planDtlId) => {
    const { vendorPlanList } = this.state;
    const current = vendorPlanList.find(
      (task) => task.ExhVendorPlanDtlID === planDtlId
    );

    if (current && this.isTaskLocked(current)) {
      toastError(this.lockedMessage(this.isFlagOn(current.IsAdminApprove)));
      return;
    }

    const updatedList = vendorPlanList.map((task) => {
      if (task.ExhVendorPlanDtlID === planDtlId) {
        return { ...task, IsCompleted: !task.IsCompleted };
      }
      return task;
    });

    this.setState({ vendorPlanList: updatedList }, () => {
      const updatedTask = updatedList.find(
        (task) => task.ExhVendorPlanDtlID === planDtlId,
      );
      this.updateVendorTasks([
        {
          ExhVendorplandtlID: planDtlId,
          IsCompleted: updatedTask.IsCompleted,
        },
      ]);
    });
  };

  // Organizer approval of a deliverable. Sent on its own with IsCompleted: null -
  // approving must not rewrite the completion this browser read seconds ago,
  // and it must not cascade to the sub points the way a completion does
  toggleTaskApproval = (planDtlId) => {
    const { vendorPlanList, isAdmin } = this.state;

    if (!isAdmin) return;

    const updatedList = vendorPlanList.map((task) =>
      task.ExhVendorPlanDtlID === planDtlId
        ? { ...task, IsAdminApprove: !this.isFlagOn(task.IsAdminApprove) }
        : task
    );

    this.setState({ vendorPlanList: updatedList }, () => {
      const updatedTask = updatedList.find(
        (task) => task.ExhVendorPlanDtlID === planDtlId
      );

      this.updateTaskApproval(
        planDtlId,
        "IsAdminApprove",
        updatedTask.IsAdminApprove ? 1 : 0
      );
    });
  };

  // Hall manager approval of a deliverable - one step before the organizer's, and
  // stored in its own column so neither approval reads as the other
  toggleTaskHallApproval = (planDtlId) => {
    const { vendorPlanList } = this.state;
    const current = vendorPlanList.find(
      (task) => task.ExhVendorPlanDtlID === planDtlId
    );

    if (!current) return;

    if (!this.canSetHallApproval(this.isFlagOn(current.IsAdminApprove))) {
      if (this.state.isHallManager) toastError(this.lockedMessage(true));
      return;
    }

    const updatedList = vendorPlanList.map((task) =>
      task.ExhVendorPlanDtlID === planDtlId
        ? {
          ...task,
          IsHallManagerApprove: !this.isFlagOn(task.IsHallManagerApprove),
        }
        : task
    );

    this.setState({ vendorPlanList: updatedList }, () => {
      const updatedTask = updatedList.find(
        (task) => task.ExhVendorPlanDtlID === planDtlId
      );

      this.updateTaskApproval(
        planDtlId,
        "IsHallManagerApprove",
        updatedTask.IsHallManagerApprove ? 1 : 0
      );
    });
  };

  // Zone manager verification of a deliverable
  toggleTaskZoneApproval = (planDtlId) => {
    const { vendorPlanList } = this.state;
    const current = vendorPlanList.find(
      (task) => task.ExhVendorPlanDtlID === planDtlId
    );

    if (!current) return;

    if (
      !this.canSetZoneApproval(
        this.isFlagOn(current.IsHallManagerApprove),
        this.isFlagOn(current.IsAdminApprove)
      )
    ) {
      if (this.state.isZoneManager) {
        toastError(this.zoneLockedMessage(this.isFlagOn(current.IsAdminApprove)));
      }
      return;
    }

    const updatedList = vendorPlanList.map((task) =>
      task.ExhVendorPlanDtlID === planDtlId
        ? {
          ...task,
          IsZoneManagerApprove: !this.isFlagOn(task.IsZoneManagerApprove),
        }
        : task
    );

    this.setState({ vendorPlanList: updatedList }, () => {
      const updatedTask = updatedList.find(
        (task) => task.ExhVendorPlanDtlID === planDtlId
      );

      this.updateTaskApproval(
        planDtlId,
        "IsZoneManagerApprove",
        updatedTask.IsZoneManagerApprove ? 1 : 0
      );
    });
  };

  updateTaskApproval = (planDtlId, field, isApproved) => {
    const ExhVendorPlanHdrID = this.getPlanHdrIDForTask(planDtlId);

    const taskDetails = [
      {
        ExhVendorplandtlID: planDtlId,
        IsCompleted: null,
        [field]: isApproved,
        Remark: null,
        ZoneID: this.getZoneIDForTask(planDtlId),
      },
    ];

    this.isTaskUpdateInFlight = true;
    this.props
      .updateVendorTask_action(ExhVendorPlanHdrID, taskDetails, [], [])
      .then((data) => {
        if (data.error != 1) {
          toastSuccess("Verification updated successfully!");
          this.getVendorTaskList(this.state.filterStatus, true);
        } else {
          toastError(data.msg);
        }
        this.isTaskUpdateInFlight = false;
      })
      .catch((err) => {
        console.log(err);
        toastError("Something went wrong!");
        this.isTaskUpdateInFlight = false;
      });
  };

  handleDateChange = (value, field, planDtlId) => {
    const { vendorPlanList } = this.state;
    const updatedList = vendorPlanList.map((task) => {
      if (task.ExhVendorPlanDtlID === planDtlId) {
        return { ...task, [field]: value };
      }
      return task;
    });

    this.setState({ vendorPlanList: updatedList });
    console.log("Date changed:", { value, field, planDtlId });
  };

  downloadExcel = () => {
    const { vendorPlanList } = this.state;

    if (!vendorPlanList || vendorPlanList.length === 0) {
      alert("No data to export");
      return;
    }

    const headers = [
      "Person Name",
      "Email",
      "Mobile",
      "Hall Name",
      "Zone Name",
      "Start Time",
      "End Time",
      "Service Name",
      "Deliverables",
      "Is Completed",
    ];

    const data = vendorPlanList.map((task) => [
      task.vendorPersonName || "",
      task.vendorEmail || "",
      task.vendorMobile || "",
      task.HallName || "",
      task.ZoneName || "",
      task.StartTime || "",
      task.EndTime || "",
      task.ServiceName || "",
      task.DeliverablesServiceName || "",
      task.IsCompleted ? "Yes" : "No",
    ]);

    const aoa = [headers, ...data];

    const ws = XLSX.utils.aoa_to_sheet(aoa);

    // Header styling
    for (let col = 0; col < headers.length; col++) {
      const cellRef = XLSX.utils.encode_cell({ r: 0, c: col });

      if (ws[cellRef]) {
        ws[cellRef].s = {
          fill: { fgColor: { rgb: "FF4472C4" } },
          font: { bold: true, color: { rgb: "FFFFFFFF" } },
          alignment: { horizontal: "center", vertical: "center" },
        };
      }
    }

    // Apply red background to overlapped rows
    vendorPlanList.forEach((task, index) => {
      const isOverlapped =
        task.IsOverLapped === true || task.IsOverLapped === 1;

      if (isOverlapped) {
        const rowIndex = index + 1;

        for (let col = 0; col < headers.length; col++) {
          const cellRef = XLSX.utils.encode_cell({ r: rowIndex, c: col });

          if (ws[cellRef]) {
            ws[cellRef].s = {
              fill: { fgColor: { rgb: "FFFF0000" } },
              font: { color: { rgb: "FFFFFFFF" } },
            };
          }
        }
      }
    });

    // Column widths
    ws["!cols"] = [
      { wch: 20 },
      { wch: 25 },
      { wch: 18 },
      { wch: 18 },
      { wch: 18 },
      { wch: 18 },
      { wch: 18 },
      { wch: 50 },
      { wch: 15 },
    ];

    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, "All Tasks");

    XLSX.writeFile(wb, "vendor_all_tasks.xlsx");
  };

  updateVendorTasks = (taskDetails) => {
    const { vendorPlanList } = this.state;
    // These calls carry a single deliverable, so the header is that row's
    const ExhVendorPlanHdrID = this.getPlanHdrIDForTask(
      taskDetails[0]?.ExhVendorplandtlID
    );

    const dailyRoutineTaskDetails = taskDetails
      .map((task) => {
        const planTask = vendorPlanList.find(
          (t) => t.ExhVendorPlanDtlID === task.ExhVendorplandtlID,
        );
        return {
          DailyRoutineHallChecklistMappingID:
            planTask?.DailyRoutineHallChecklistMappingID || null,
          IsApproved: task.IsCompleted,
        };
      });

    // A completion carries no message, but Remark still travels as null so the
    // SP always sees the same row shape
    const taskRows = taskDetails.map((row) => ({
      Remark: null,
      ...row,
      ZoneID: this.getZoneIDForTask(row.ExhVendorplandtlID),
    }));

    // Ticking a task cascades to its sub points inside the SP, so the sub point
    // set is left out - sending it would only push values read earlier back over
    // whatever another user changed since
    this.isTaskUpdateInFlight = true;
    this.props
      .updateVendorTask_action(
        ExhVendorPlanHdrID,
        taskRows,
        [],
        dailyRoutineTaskDetails,
      )
      .then((data) => {
        if (data.error != 1) {
          console.log(`Tasks updated successfully!`);
          this.getVendorTaskList();
        } else {
          toastError(data.msg);
        }
        this.isTaskUpdateInFlight = false;
      })
      .catch((err) => {
        console.log(err);
        toastError("Something went wrong!");
        this.isTaskUpdateInFlight = false;
      });
  };

  render() {
    const {
      isLoading,
      showVideoModal,
      ExhibitionID,
      WorkOrderNumber,
      PersonName,
      ServiceID,
      currentPage,
      exhibitionList,
      EmailID,
      Status,
      WorkOrderServiceList,
      workOrderList,
      isOpen,
      isVendor,
    } = this.state;

    const recordsPerPage = 10;
    const indexOfLastRecord = currentPage * recordsPerPage;
    const indexOfFirstRecord = indexOfLastRecord - recordsPerPage;
    const currentRecords = workOrderList.slice(
      indexOfFirstRecord,
      indexOfLastRecord,
    );
    const nPages = Math.ceil(workOrderList.length / recordsPerPage);

    console.log("currentRecords", currentRecords);

    // Inside the layout view's modal the page chrome would be wrong - no second
    // header, drawer or ToastContainer. The table and the popups it opens are
    // the whole point, and they are rendered exactly as they are on the page.
    if (this.props.embedded) {
      return (
        <>
          {isLoading ? <Loader></Loader> : null}
          {this.renderDirectTaskTable()}
          {this.renderRemarkModal()}
          {this.renderAttachmentModal()}
        </>
      );
    }

    return (
      <>
        {isLoading ? <Loader></Loader> : null}
        <ToastContainer />
        {isVendor && showVideoModal && (
          <div
            className="modal show d-block"
            style={{ backgroundColor: "rgba(0,0,0,0.5)" }}
            onClick={() => this.setState({ showVideoModal: false })}
          >
            <div
              className="modal-dialog modal-lg modal-dialog-centered"
              onClick={(e) => e.stopPropagation()}
            >
              <div className="modal-content">
                <div className="modal-header">
                  <h5 className="modal-title">Task</h5>
                  <button
                    type="button"
                    className="btn-close"
                    onClick={() => this.setState({ showVideoModal: false })}
                  ></button>
                </div>
                <div className="modal-body">
                  <video controls autoPlay style={{ width: "100%" }}>
                    <source src="/assets/VendorTask.mp4" type="video/mp4" />
                  </video>
                </div>
              </div>
            </div>
          </div>
        )}
        {JSON.parse(sessionStorage.getItem("loginDataSS")).RoleID == 1 ? (
          <ExhibitorHeader />
        ) : (
          <HeaderWithLogo />
        )}
        <div
          className={
            JSON.parse(sessionStorage.getItem("loginDataSS")).RoleID == 1
              ? "with-dr-container"
              : JSON.parse(sessionStorage.getItem("loginDataSS")).RoleID == 6 || JSON.parse(sessionStorage.getItem("loginDataSS")).RoleID == 24 ||
                JSON.parse(sessionStorage.getItem("loginDataSS")).RoleID ==
                16 ||
                JSON.parse(sessionStorage.getItem("loginDataSS")).RoleID == 20
                ? "com-height"
                : "with-dr-container com-height"
          }
          style={{
            margin:
              JSON.parse(sessionStorage.getItem("loginDataSS")).RoleID == 7 ||
                JSON.parse(sessionStorage.getItem("loginDataSS")).RoleID == 16 ||
                JSON.parse(sessionStorage.getItem("loginDataSS")).RoleID == 20 ||
                JSON.parse(sessionStorage.getItem("loginDataSS")).RoleID == 25 ||
                JSON.parse(sessionStorage.getItem("loginDataSS")).RoleID == 17
                ? 0
                : "",
          }}
        >
          <div class="main-content admin-top-space">
            {JSON.parse(sessionStorage.getItem("loginDataSS")).RoleID == 1 ? (
              <ExhibitorDrawer />
            ) : (JSON.parse(sessionStorage.getItem("loginDataSS")).RoleID ==
              7 || JSON.parse(sessionStorage.getItem("loginDataSS")).RoleID ==
              17) ? (
              <VendorDrawer />
            ) : JSON.parse(sessionStorage.getItem("loginDataSS")).RoleID ==
              16 ||
              JSON.parse(sessionStorage.getItem("loginDataSS")).RoleID ==
              25 ||
              JSON.parse(sessionStorage.getItem("loginDataSS")).RoleID ==
              20 ? null : (
              <AdminDrawer />
            )}
            {JSON.parse(sessionStorage.getItem("loginDataSS")).RoleID == 1 ? (
              <ExhibitorTopMenu />
            ) : null}
            {this.renderDirectTaskTable()}
          </div>
        </div>

        {this.renderRemarkModal()}

        {this.renderAttachmentModal()}

        <Modal
          isOpen={isOpen}
          onRequestClose={() => this.setState({ isOpen: false })}
        >
          <div className="modal-dialog">
            <div className="modal-content confirm-logout">
              <div class="modal-header text-right p-2">
                <h5 class="modal-title">
                  Do you really want to delete this record?
                </h5>
              </div>
              <div class="modal-footer p-1">
                <div class="form-group text-right mod-fot">
                  <button
                    type="button"
                    class="btn btn-del-pop"
                    onClick={(e) => this.deleteWorkOrder()}
                  >
                    Yes
                  </button>
                  <button
                    type="button"
                    class="btn btn-gray"
                    data-dismiss="modal"
                    style={{ marginLeft: "5px" }}
                    onClick={() => this.setState({ isOpen: false })}
                  >
                    No
                  </button>
                </div>
              </div>
            </div>
          </div>
        </Modal>
      </>
    );
  }
}
export default withRouter(
  connect(null, {
    fill_action,
    getVendorWorkOrderList_action,
    deleteVendorWorkOrder_action,
    getVendorTaskList_action,
    updateVendorTask_action,
  })(VendorTaskDetail),
);
